<template lang="pug">
    el-dialog(title="成绩管理",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body='true')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 分级公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                    div.width_label(v-if="ruleForm.ctType === 1") 常规赛
                    div.width_label(v-if="ruleForm.ctType === 2") 月度赛
                    div.width_label(v-if="ruleForm.ctType === 3") 季度赛
                    div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="比赛项目" prop="projectType")
                    div.width_label(v-if="ruleForm.projectType === 1") 单打
                    div.width_label(v-if="ruleForm.projectType === 2") 双打
                el-form-item(label="级别" prop="level")
                    div.width_label {{ruleForm.level}}
                el-form-item(label="签位" prop="applySize")
                    div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                br
                el-form-item(label="比赛时间")
                    div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                el-form-item(v-if="ruleForm.projectType === 2" label="排序")
                    el-select(v-model="ruleForm.orderForm" @change="orderChange")
                        el-option(label="按级别和-积分和" :value=1 )
                        el-option(label="按级别差-积分和" :value=2 )
        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 比赛成绩录入
                    div
                        el-table(:data="gradeData" border)
                            el-table-column(prop="name" label="姓名" align="center")
                            el-table-column(prop="mobile" label="手机号" align="center")
                            el-table-column(prop="rank" label="排名" align="center")
                                template(slot-scope="scope")
                                    el-input-number(v-model="scope.row.rank" :min="0")
                            el-table-column(prop="score" label="积分" align="center" :min="0")
                                template(slot-scope="scope")
                                    el-input-number(v-model="scope.row.score")
                        //- 二期改造内容,暂时先屏蔽
                        //- div(class="marginBottom")
                        //-     el-button(v-for="matchRound of [{round:1}, {round:2}]" :key="matchRound.round" @click="chooseRound(matchRound.round)") {{ matchRound.round }}R
                        //-     el-button(@click="chooseRound('leaderBoard')" type="primary") add排行榜
                        //- el-table(v-if="isRoundView" :data="mockData" border)
                        //-     el-table-column(prop="name" label="比赛时间" align="center")
                        //-     el-table-column(prop="name" label="姓名" align="center")
                        //-     el-table-column(prop="name" label="让分" align="center")
                        //-     el-table-column(prop="name" label="本轮得分" align="center")
                        //-     el-table-column(prop="name" label="操作" align="center" width="300")
                        //-         template(slot-scope="scope")
                        //-             el-button(type="text" @click="updateGrade") 修改成绩
                        //-             el-button(type="text" @click="viewDispute") 查看争议
                        //-             el-button(type="text" @click="viewPhotos") 查看照片打卡
                        //- el-table(v-if="!isRoundView" :data="gradeData" border)
                        //-     el-table-column(prop="name" label="名次" align="center")
                        //-     el-table-column(prop="name" label="姓名" align="center")
                        //-     el-table-column(prop="name" label="总得分" align="center")
                        //-     el-table-column(prop="name" label="积分" align="center")
                        //-     el-table-column(prop="name" label="升级点数" align="center")
        span.dialog-footer(slot="footer")
            el-button(@click="comfirmClick" type="primary") 确 定
            el-button(@click="visible=false") 取 消
        updateGrade(v-if='updateGradeVisible' ref="updageGrade")
        viewDispute(v-if='viewDisputeVisible' ref="viewDispute")
        viewPhotos(v-if='viewPhotosVisible' ref="viewPhotos")
</template>
<script>
import UpdateGrade from './update-grade'
import ViewDispute from './view-dispute'
import ViewPhotos from './view-photos'
export default{
    data () {
        return {
            visible: false,
            ruleForm: {
                id: null,
                matchType: '1'
            },
            gradeData: [],
            loading: null,
            isRoundView: true,
            mockData: [{ name: 'wanghaibo' }],
            updateGradeVisible: false,
            viewDisputeVisible: false,
            viewPhotosVisible: false,
            matchGameData: [], // 对阵表数据
            gameRankData: [] // 排行榜数据
        }
    },
    components: {
        UpdateGrade,
        ViewDispute,
        ViewPhotos
    },
    methods: {
        // 成绩管理-比赛成绩录入-对阵表数据
        getGameData () {
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/operation/achievement-manage/against-list/` + this.ruleForm.id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.matchGameData = data.data
                }
            })
        },
        // 成绩管理-比赛成绩录入-排行榜
        getRankData () {
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/operation/achievement-manage/ranking-list/` + this.ruleForm.id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.gameRankData = data.data
                }
            })
        },
        // 修改成绩操作
        updateGrade () {
            this.updateGradeVisible = true
            this.$nextTick(() => {
                this.$refs.updageGrade.init()
            })
        },
        // 查看争议
        viewDispute () {
            this.viewDisputeVisible = true
            this.$nextTick(() => {
                this.$refs.viewDispute.init()
            })
        },
        // 查看照片打卡
        viewPhotos () {
            this.viewPhotosVisible = true
            this.$nextTick(() => {
                this.$refs.viewPhotos.init()
            })
        },
        // 成绩管理录入数据查看事件
        chooseRound (type) {
            if (type) {
                this.isRoundView = false
            } else {
                this.isRoundView = true
            }
        },
        init (row) {
            this.visible = true
            this.gradeData = null
            //回选
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/getId/` + row.id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.ruleForm = data.bean
                    let joinCount = this.ruleForm.joinCount//已报名参赛人员的人数
                    let applySize = this.ruleForm.applySize//赛事签位数
                    let date1 = new Date().getTime()
                    let date2 = new Date(this.ruleForm.matchStartTime).getTime()
                    let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
                    let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
                    if (date1 < date3) {
                        this.ruleForm.statusName = '未开始'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount < applySize) {
                        this.ruleForm.statusName = '报名中'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount >= applySize) {
                        this.ruleForm.statusName = '报满可替'
                    } else if (date1 > date4 && date1 < date2) {
                        this.ruleForm.statusName = '报名结束'
                    } else if (date1 >= date2) {
                        this.ruleForm.statusName = '已开赛'
                    }
                    this.ruleForm.orderForm = 1
                }
            }).then(() => {
                this.getEnrollData(row.id)
            })
        },
        orderChange () {
            this.getEnrollData(this.ruleForm.id)
        },
        //列表刷新
        getEnrollData (id) {
            let params = { 'ctId': id }
            if (this.ruleForm.projectType == 1) {
                //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
                params.orderForm = 0
            } else if (this.ruleForm.projectType == 2) {
                //双打默认按级别和-积分和排序
                params.orderForm = 1
            }
            this.$http({
                url: this.$http.adornUrl(`/elEnrollOrder/getScoreList`),
                method: 'post',
                params: this.$http.adornParams(params)
            }).then((data) => {
                if (data && data.code === 0) {
                    this.gradeData = data.list
                    for (let i of this.gradeData) {
                        if (i.score == null) {
                            i.score = undefined
                        }
                        if (i.rank == null) {
                            i.rank = undefined
                        }
                    }
                }
            })
        },
        openFullScreen () {
            this.loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        },
        //提交事件
        comfirmClick () {
            let submitData = []
            //封装提交数据
            let flag = false
            for (let i of this.gradeData) {
                if (!i.rank) {
                    this.$message.error('请输入排名!')
                    flag = true
                    return
                }
                if (!i.score && i.score != 0) {
                    this.$message.error('请输入积分!')
                    flag = true
                    return
                }
                submitData.push({
                    id: i.scoreId,
                    matchInfoId: this.ruleForm.id, //赛事id
                    matchType: 1, //1:分级赛
                    enrollId: i.enrollId, //报名id
                    participantInfoId: i.mbId, //人员id
                    participantInfoRealName: i.name,
                    rank: i.rank,
                    score: i.score,
                    byx1: i.level
                })
            }
            if (flag) {
                this.$message.error('请输入全部成绩信息!')
                return
            }
            this.openFullScreen()
            this.$http({
                url: this.$http.adornUrl(`/ctScore/saveOrUpdate`),
                method: 'post',
                data: submitData
            }).then((data) => {
                if (data && data.code === 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.visible = false
                            this.$emit('refreshDataList')
                        }
                    })
                } else {
                    this.$message.error('添加失败!')
                }
                this.loading.close()
            })
        }
    }
}
</script>
<style scoped>
.marginBottom {
    margin-bottom: 20px;
}
</style>
